module.exports = __webpack_public_path__ + "img/ivory.3d823be1.webp";